export default __webpack_public_path__ + "static/media/ckb.03fc4c29.png";